var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
var defaultSortParam = 'codi';
var defaultSortDirection = 'asc';
var DesplacatsGruaFilterService = /** @class */ (function (_super) {
    __extends(DesplacatsGruaFilterService, _super);
    function DesplacatsGruaFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DesplacatsGruaFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('matricula', filter.matricula)
            .append('marca', filter.marca)
            .append('modelo', filter.modelo)
            .append('somIdCalle', filter.somIdCalle)
            .append('dataInici', filter.dataInici ? filter.dataInici.toUTCString() : null)
            .append('dataFi', filter.dataFi ? filter.dataFi.toUTCString() : null)
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return DesplacatsGruaFilterService;
}(CustomFilterService));
export { DesplacatsGruaFilterService };
